import PropTypes from 'prop-types'

const Logomark = ({ style, fill }) => {
  return (
    <img 
      src="/dansk_samtale_logo.png" 
      alt="Dansk Samtale" 
      style={{ 
        height: '20px', 
        ...style 
      }} 
    />
  )
}

Logomark.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string
}

export default Logomark
